<template>
  <div class="cart-page-1">
    <div class="content-box">
      <div class="border1"></div>

      <div v-if="defaultAddress" class="flex-row col-center row-center box1">
        <van-icon name="location-o" style="color: #cfcfcf; font-size: 18px" />
        <div class="ml8 mr8 text-overflow-hidden" style="width: 284px; font-size: 15px">
          <span v-if="defaultAddress">{{ defaultAddress.cityName }} {{ defaultAddress.address }}</span>
        </div>
        <div class="ml8" style="color: #0f5fc5;">
          <router-link to="/user-center-address">编辑</router-link>
        </div>
      </div>
      <div v-else class="flex-row col-center row-center box1" style="color: #0f5fc5;">
        没有默认收货地址？
        <router-link style="margin-left: 8px" to="/user-center-address">
          <van-button size="small">立即设置</van-button>
        </router-link>
      </div>

      <div class="box2">
        <div v-if="!$store.getters.cart || $store.getters.cart.length < 1" style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 450px;
          ">
          <img :src="`${publicPath}images/common/cart-empty.png`" style="width: 100px; margin-bottom: 12px" />
          <div style="text-align: center; color: #afafaf;margin-bottom: 35px">
            您的购物车还是空的哦 ~<br />
            赶紧去逛逛
          </div>
          <!--          <van-button type="info" to="/">去商城首页</van-button>-->
        </div>

        <van-checkbox-group ref="goods-list" v-model="selectedIds" checked-color="#FC3F3F" icon-size="15px"
          v-on:change="checked">
          <van-checkbox v-for="(item, index) of $store.getters.cart" :key="index" :name="item" class="goods-item-box"
            style="padding-top: 10px">
            <div class="goods-header" style="font-size: 14px; margin-bottom: 5px">
              <span v-if="item.goods.supplierId === 1" style="
                  color: #fff;
                  background: #f00;
                  font-size: 12px;
                  padding: 2px 5px;
                  border-radius: 2px;
                ">自营</span>
              <span v-else>仓库{{ item.goods.supplierId }}</span>
            </div>
            <div class="flex-row">
              <img :src="item.goods.img" alt="" style="width: 95px; height: 95px" />
              <div class="flex-col row-between ml11">
                <div>
                  <div style="font-size: 14px">{{ item.goods.name }}</div>
                  <div class="mt6" style="font-size: 11px; color: #a0a0a0">
                    {{ Array.isArray(item.goods.spec) ? item.goods.spec.join(",") : "" }}
                  </div>
                </div>
                <div class="flex-row row-between col-center" style="width: 210px">
                  <div style="font-size: 18px">
                    <span style="color: #fc3f3f">{{ item.goods.price | money }}</span>
                  </div>
                  <div v-on:click.stop="">
                    <van-stepper :value="item.count" async-change button-size="23px" disable-input integer min="1"
                      @change="countChange($event, item.goods.goodsId, item.goods.spec)" />
                  </div>
                </div>
              </div>
            </div>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <div v-if="Array.isArray($store.getters.cart) && $store.getters.cart.length > 0"
        class="box4 flex-row col-center row-between">
        <div class="flex-row" style="margin-left: 13px">
          <van-checkbox v-model="selectAll" checked-color="#FC3F3F" icon-size="15px" @change="checkAll"></van-checkbox>
          <span class="ml4" style="font-size: 12px; color: #666666">全选</span>
          <span class="ml14" style="font-size: 12px; color: #666666" @click="clearCart">清空</span>
        </div>
        <div class="flex-row">
          <div class="flex-row col-center">
            <span style="font-size: 15px">
              合计:
              <span style="color: #ff7800; font-size: 12px">￥</span>
              <span style="color: #ff7800">{{ total | money }}</span>
            </span>
          </div>
          <div v-if="total > 0" class="text-center ml4" style="
              height: 50px;
              width: 115px;
              background-color: #fc3f3f;
              color: white;
              line-height: 50px;" @click="submitNewOrder"> 去结算 </div>
          <div v-else class="text-center ml4" style="
              height: 50px;
              width: 115px;
              background-color: #ccc;
              color: white;
              line-height: 50px; "> 去结算 </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GOODS_TYPE_GENERAL_GOODS } from "@/api/constant";

export default {
  name: "cart",

  data() {
    return {
      publicPath: process.env.BASE_URL,
      cart: this.$store.getters.cart,
      selectedIds: [],
      selectAll: false,
      total: 0,
      defaultAddress: this.$store.getters.address,
    };
  },

  computed: {},

  created() {
    if (this.cart && Array.isArray(this.cart) && this.cart.length > 0) {
      this.selectedIds = this.cart.filter((item) => item.checked === true);
      this.updateTotal();

      budo_log.info("#211 购物车数据：", this.cart);
    }

    this.$store.dispatch("GetDefaultAddress");
  },

  methods: {
    countChange(count, goodsId, spec) {
      budo_log.debug("#218 countChange", count)

      const goodsInfo = { goodsId, count, spec };
      this.$store.dispatch('updateCartCount', goodsInfo).then(() => {
        this.updateTotal();
      });
    },

    submitNewOrder() {
      const goodsInfo = this.cart[0];

      budo_log.info("#202 go user-center-order-submit /user-center-order-submit", goodsInfo)

      this.$router.push({
        path: "/user-center-order-submit",
        query: {
          goodsType: goodsInfo.goods.goodsType,
          cateId: goodsInfo.goods.cateId,
        },
      });
    },

    checked(e) {
      budo_log.info("#235 checked", e)

      this.selectedIds = e;
      this.updateTotal();
    },

    clearCart() {
      this.$store.commit("CLEAR_CART");
      this.total = 0;
    },

    checkAll(e) {
      if (this.selectedIds.length > 0 && e === false && this.selectedIds.length < this.cart.length) {
        return
      }

      if (e) {
        this.cart.forEach((item) => (item.checked = e));
      } else {
        this.total = 0;
      }
      this.updateTotal();
      this.$refs["goods-list"].toggleAll(e);
    },

    updateTotal(resetCheck = true) {
      budo_log.debug("#258 updateTotal", this.cart);

      if (this.cart && Array.isArray(this.cart) && this.cart.length > 0) {
        if (resetCheck) {
          this.cart.forEach((item) => (item.checked = false));
        }

        this.selectAll = this.selectedIds.length === this.cart.length;

        if (this.selectedIds.length > 0) {
          this.selectedIds.forEach((id) => {
            const goods = this.cart.find((item) => item === id);
            if (goods) {
              goods.checked = true;
            }
          });

          const gs = this.cart.filter((item) => item.checked === true);
          budo_log.debug("#207 updateTotal, gs=", gs);

          if (Array.isArray(gs) && gs.length > 0) {
            this.total = gs
              .map((item) => item.goods.price * item.count)
              .reduce((a, b) => a + b);
          } else {
            this.total = 0;
          }
        } else {
          this.total = 0;
        }

        const newOrderInfo = {
          goodsType: GOODS_TYPE_GENERAL_GOODS,
          userAddressId: this.defaultAddress.addressId,
          total: this.total,
          cityCode: this.$store.getters.city_code,
          goodsList: this.cart.filter((item) => item.checked === true),
          timeId: new Date().getTime(),
        };

        this.$store.dispatch("actions_createOrderInfo", newOrderInfo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
